import { atom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase } from "./BaseApi";

export type PostUserResponseParam = {
  responseList: {
    questionId: string;
    choiceId: string;
  }[];
  checkList: {
    checkId: string;
    isChecked: string;  // "0" / "1"
  }[];
};

const unregisteredUri = "api/unregistered-users/user-response";
const uri = "api/users/user-response";

export const postUserResponseAtom = atom<State<null> | null>(null);

export const postUnregisteredUserResponse = () => {
  return postBase<null, PostUserResponseParam>(
    unregisteredUri,
    postUserResponseAtom
  );
};

export const postRegisteredUserResponse = () => {
  return postBase<null, PostUserResponseParam>(
    uri,
    postUserResponseAtom
  );
};
